import {combineReducers} from 'redux';
import login from './login';
import logout from './logout';
import user from './user';
import sms from './sms';
import smsHistory from './smsHistory';
import group from './group';
import adminPanel from './adminPanel';
import dashboard from './dashboard';
import blockedContacts from './blockedContacts';
import template from './template';
import creditHistory from './creditHistory'
import balanceUsage from './balanceUsage'
import billing from './billing'
import onboarding from './onboarding'
import lifecycle from './lifecycle'
import manageOperators from './manageOperators'
import rateLimit from './rateLimit'
import opsDashboard from './opsDashboard'

export default combineReducers({
  loginResponse: login,
  logoutResponse: logout,
  userResponse: user,
  smsResponse: sms,
  smsHistory,
  group,
  adminPanel,
  dashboard,
  blockedContacts,
  template,
  creditHistory,
  balanceUsage,
  billing,
  onboarding,
  lifecycle,
  manageOperators,
  rateLimit,
  opsDashboard
});
